import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const [cities, setCities] = useState([]);
  const [filterCities, setFilterCities] = useState([]);
  const [search, setSearch] = useState("");

  const getCities = async () => {
    try {
      let response = await axios.get(
        "https://mtrip-dynamic.herokuapp.com/cities"
      );
      setCities([...response.data]);
      setFilterCities([...response.data]);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => getCities(), []);

  useEffect(() => {
    const data = cities.filter((city) =>
      city.city.toLowerCase().match(search.toLowerCase())
    );
    console.log(data);
    setFilterCities([...data]);
  }, [search]);

  return (
    <>
      <div className="hero col-12 d-flex justify-content-center align-items-center flex-column text-light">
        <h1>Welcome to Trip</h1>
        <h5 className="text-center">
          Explore the world with fantastic places to venture around
        </h5>
        <input
          type="text"
          placeholder="Search a City"
          className="form-control w-50"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="cities container">
        <div className="row mt-5">
          {filterCities.map((city) => (
            <div className="col-lg-3 col-sm-6 col-xs-12 mb-3">
              <Link to={`/adventure/${city.id}`}>
                <div className="card">
                  <img
                    src={city.image}
                    alt={city.city}
                    className="card-img-top img-fluid"
                  />
                  <div className="desc text-light d-flex flex-column w-100 align-items-center">
                    <strong>{city.city}</strong>
                    <strong>{city.description}</strong>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Home;
